import { useState } from 'react';
import './MenuList.style.css';
import { Avatar, Button } from 'antd';
import { Title } from 'components';
import { PlusSquareOutlined, MinusSquareOutlined } from '@ant-design/icons';

/**
 * MenuList
 */
const MenuList = ({ title, data, onMenuSelect, selectedItem }) => {
  /* ===== State ===== */
  const [isOpen, setIsOpen] = useState(false);

  /* ===== ===== */
  return (
    <div className="menulist_layout">
      {/* 카테고리 제목 */}
      <div className="menulist_header">
        {/* <h4>{title}</h4> */}
        <Title
          size={5}
          className="cursorOverOpacity"
          onClick={() => setIsOpen(!isOpen)}
          subButton={
            <Button size="small" type="text" style={{ padding: 0, margin: 0 }}>
              {isOpen === true ? (
                <MinusSquareOutlined style={{ fontSize: '1.25em' }} />
              ) : (
                <PlusSquareOutlined style={{ fontSize: '1.25em' }} />
              )}
            </Button>
          }
        >
          {title}
        </Title>
        {/* <TitleComp */}
      </div>

      {/* 하위 카테고리 및 메뉴 */}
      {isOpen && (
        <div className="menulist_content">
          {data?.subCategories?.map((subCategory) => (
            <div
              key={subCategory.product_category_id}
              className="subcategory_section"
            >
              <h5 className="subcategory_title">
                {subCategory.product_category_name}
              </h5>
              <div className="subcategory_menus">
                {subCategory.menus?.map((menu) => (
                  <MenuItem
                    key={menu.menu_id}
                    menu={menu}
                    onMenuSelect={onMenuSelect}
                    isSelected={selectedItem?.menu_id === menu.menu_id}
                  />
                ))}
              </div>
            </div>
          ))}
          {data?.menus?.map((menu) => (
            <MenuItem
              key={menu.menu_id}
              menu={menu}
              onMenuSelect={onMenuSelect}
              isSelected={selectedItem?.menu_id === menu.menu_id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const MenuItem = ({ menu, onMenuSelect, isSelected }) => (
  <div
    onClick={() => onMenuSelect(menu)}
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      cursor: 'pointer',
      border: isSelected ? '1px solid #2394E4' : '1px solid #EFEFEF',
      background: isSelected ? 'rgba(28, 107, 244, 0.3)' : '#FFFFFF',
      marginTop: '5px',
    }}
  >
    <Avatar shape="square" size={30} src={menu?.thumbnail} />
    <div style={{ paddingLeft: '10px' }}>
      <h4 style={{ margin: 0 }}>{menu.menu_name}</h4>
      <p style={{ margin: 0 }}>{menu.price}원</p>
    </div>
  </div>
);

export default MenuList;
